import { EntityController } from "./EntityController";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { CocosUtils } from "../../tools/CocosUtils";
import { PlanManager } from "../../cocosPlan";
import { ArrangementGroup, ArrangementObject, Commands, Events, eventsManager, SceneConstants } from "@rhinov/savane-js";
import { _ASSET_TYPE, ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, createAssetEntity, getAsset, getAssets, getFrontUrl, getMediaArrangementUrl, getResourcesPinboards, getToken } from "@rhinov/asset-manager-service";




export class ArrangementObjectEntityController extends EntityController {

    designer: any;
    OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS: string = '&fields=kind,marketName,price,genericName,name,randomization,dimensions,displayDimensions,sketchBlock,_id,marketLink,configs,colors,stretchability,objectType,type,manufacturer,retailer,pipeline.state,pipeline.modelState,styles,marketStatus,isNewProduct';

    // Close arrangement objects to the current arrangement object
    closeModelsForCurrentArrangementObject: any = [];
    declare entity: ArrangementObject | ArrangementGroup;

    constructor(entity: ArrangementObject | ArrangementGroup, panel: any, deliverable: any, designer: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.arrangement = null;
        this.entity = entity;
        this.designer = designer;
        this.dropDownDatas.wallCoveringList = [];
        this.updatepreviewArrangement();

    }

    arrangementCanHaveOrientedHandles(): boolean {
        if (this.entity.isArrangementObjectEntity())
        {
            var entity = this.entity as ArrangementObject;
            if (entity.getZones(SceneConstants.ArrangementZoneType.handleleft).length > 0 ||
                entity.getZones(SceneConstants.ArrangementZoneType.handlecenter).length > 0 ||
                entity.getZones(SceneConstants.ArrangementZoneType.handleright).length > 0) {
                return (true);
            }
        }

        return (false);
    };

    updatetripleToggleHandle() {
        let left = document.getElementById('radio-right1_handle_left') as HTMLInputElement;
        let middle = document.getElementById('radio-middle1_handle_center') as HTMLInputElement;
        let right = document.getElementById('radio-left1_handle_right') as HTMLInputElement;
    
        if (!middle || !right || !left) return;
        switch ((this.entity as ArrangementObject).getHandleSide()) {
            case -1:
                middle.checked = false;
                left.checked = true;
                right.checked = false;
                break;
            case 1:
                middle.checked = false;
                left.checked = false;
                right.checked = true;
                break;
            default:
                middle.checked = true;
                left.checked = false;
                right.checked = false;
        }
    }

    setToggleHandleValue(value: number) {
        let left = document.getElementById('radio-right1_handle_left') as HTMLInputElement;
        let middle = document.getElementById('radio-middle1_handle_center') as HTMLInputElement;
        let right = document.getElementById('radio-left1_handle_right') as HTMLInputElement;
    
        if (!middle || !right || !left) return;
        switch (value) {
            case -1:
                middle.checked = false;
                left.checked = true;
                right.checked = false;
                break;

            case 1:
                middle.checked = false;
                left.checked = false;
                right.checked = true;
                break;

            default:
                middle.checked = true;
                left.checked = false;
                right.checked = false;
        }

        if ((this.entity as ArrangementObject).handleAsset !== '') {
            getAsset(_ASSET_TYPE.ARRANGEMENTS, (this.entity as ArrangementObject).handleAsset, null, (handleAsset: any) => {
                var handleModele = handleAsset;

                if (handleModele !== null) {
                    createAssetEntity(_ASSET_TYPE.ARRANGEMENTS, handleModele, true, (handleEntity: any) => {

                        // We do as if we delete the current object
                        eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                            {
                                name: Commands.CommandEnum.DeleteEntityCommand,
                                undo: false,
                                datas: {
                                    id: this.entity.id,
                                    type: this.entity.entityType,
                                    entity: this.entity
                                }
                            });

                        // Populate the arrangement with the handle
                        (this.entity as ArrangementObject).populateWithHandles(handleEntity, value);

                        // Inform WebGL to update this object by adding it back to the scene
                        eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                            {
                                name: Commands.CommandEnum.AddEntityCommand,
                                undo: false,
                                datas: {
                                    id: this.entity.id,
                                    type: this.entity.entityType,
                                    entity: this.entity
                                }
                            });

                        // Save everything in cache
                        PlanManager.getInstance().saveInCache();
                    });
                }
            });
        }
    }

    openAssetIssue() {
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + 'create-issue?asset=' + this.arrangement._id);
            return;
        }
        window.open(getFrontUrl() + 'create-issue?asset=' + this.arrangement._id);
    };

    copyAssetID() {
        navigator.clipboard.writeText(this.arrangement._id);
        eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'ID copié dans le presse papier.' });
    }

    addOrRemoveFromPinboards() {
        eventsManager.instance.dispatch(Events.ADD_OR_REMOVE_FROM_PINBOARD, {
            item: this.arrangement,
        })
    };

    openEntityDetail() {
        var path = 'arrangements/';
        var id = this.entity.objectId;        
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    };

    openAssetDetail(res: any) {
        var path = 'arrangements/';
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    };

    openUrl = (url: string) => {
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(url);
            return;
        }
        window.open(url);
    };

    updateArrangementObjectType(ressource: any) {
        CocosUtils.replaceSelectedArrangement(ressource);
        PlanManager.getInstance().updateItemsSelected([]);
    };

    getTopFlop(resource: any): string {
        if (resource.marketStatus === 'top' || resource.marketStatus === 'noos' || resource.saleState === 'on_sold') {
            return ("rgb(0, 128, 0);font-weight: 800");
        }
        if (resource.marketStatus === 'flop' && !resource.isNewProduct) {
            return ("rgb(255, 0, 0)");
        }
        return ("rgb(128, 128, 128)");
    };

    getArrangementObjectPreviewUrl(modele: any): string {

        if (modele !== null) {
            var url = getMediaArrangementUrl() + modele._id + '/medias/previews/preview1-sm.webp';
            
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL +  modele._id +'/medias/previews/preview1-sm.webp';
            }

            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };

    generatePriceString(resource: any): string {
        var priceString = '';
        if (resource.price !== undefined && resource.price.value) {
            priceString = '' + resource.price.value;
            if (resource.price.currency !== undefined) {
                if (resource.price.currency === 'EUR') {
                    priceString += '€';
                }
                if (resource.price.currency === 'GBP') {
                    priceString += '£';
                }
                if (resource.price.currency === 'USD') {
                    priceString += '$';
                }
            }
        }
        return priceString;
    };

    loadCloseModelsForCurrentArrangementObject(callback: CallableFunction) {
        // We will search for the object type

        var allLoad = 0;
        var entity = this.entity as ArrangementObject;
        var params = this.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS +
            '&sort=-updatedAt&q.objectType.in=' + entity.objectType +
            '&q.pipeline.state.eq=available' +
            '&q.pipeline.modelState.eq=validated' +
            '&q.pipeline.unrealState.eq=ready';

        // And styles of the current object
        if (entity.objectStyles !== undefined) {
            if (entity.objectStyles.length > 0) {
                params += '&q.styles._id.in=';

                for (var i = 0; i < entity.objectStyles.length; i++) {
                    params += entity.objectStyles[i]._id;
                    if (i < entity.objectStyles.length - 1) {
                        params += ',';
                    }
                }
            }
        }
        // RAZ close object array waiting for asset manager call
        this.closeModelsForCurrentArrangementObject = [];
        // Launch the search and populate the content of closeModelsForCurrentARrangement
        getAssets(_ASSET_TYPE.ARRANGEMENTS, params, (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                this.closeModelsForCurrentArrangementObject = resources;
            }
            allLoad++;
            if (allLoad === 2) {
                callback()
            }
        });

        getAsset(_ASSET_TYPE.ARRANGEMENTS, this.entity.objectId, getToken(), (res: any) => {
            this.arrangement = res;
            this.dropDownDatas.wallCoveringList = [];
            if (res.configs !== undefined) {
                for (var i = 0; i < res.configs.length; i++) {
                    this.dropDownDatas.wallCoveringList.push({
                        name: res.configs[i].name,
                        value: (i + 1) + ''
                    });
                }
            }

            if (this.designer && this.arrangement) {
                getResourcesPinboards(this.arrangement._id, this.designer.mail, (data: any) => {
                    if (data && data.resources && this.arrangement) {
                        for (var i = 0; i < data.resources.length; i++) {
                            var pinboard = data.resources[i];
                            for (var j = 0; j < pinboard.items.length; ++j) {
                                if (this.arrangement._id === pinboard.items[j]) {
                                    this.arrangement.pinboard = true;
                                }
                            }
                        }
                    }
                    allLoad++;
                    if (allLoad === 2) {
                        callback();
                    }
                });
            } else {
                allLoad++;
                if (allLoad === 2) {
                    callback();
                }
            }
        });
    };


    generateDimensionsString(resource: any): string {
        var dimString = '';
        if (resource.dimensions !== undefined && resource.dimensions !== null) {
            var length = 0;
            var height = 0;
            var width = 0;

            if (resource.sketchBlock !== undefined && resource.sketchBlock !== null) {
                //Use standard dimensions of sketchBlock
                if (resource.sketchBlock.dimensions) {
                    length = resource.sketchBlock.dimensions.length / 10;
                    length = Number(length.toFixed(2));
                    height = resource.sketchBlock.dimensions.height / 10;
                    height = Number(height.toFixed(2));
                    width = resource.sketchBlock.dimensions.width / 10;
                    width = Number(width.toFixed(2));
                }
                dimString += 'L' + width + ' x H' + height + ' x P' + length;
            }
            else {
                length = resource.dimensions.length / 10;
                length = Number(length.toFixed(2));
                height = resource.dimensions.height / 10;
                height = Number(height.toFixed(2));
                width = resource.dimensions.width / 10;
                width = Number(width.toFixed(2));
                dimString += 'L' + width + ' x H' + height + ' x P' + length;
            }
        }
        return dimString;
    };

    updatepreviewArrangement() {
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            this.itemPreview = ARRMGR_CLOUDINARY_URL + this.entity["objectId"] + '/medias/previews/preview' + (this.entity as any)["colorId"] + '-sm.webp';
        } else {
            this.itemPreview = getMediaArrangementUrl() + this.entity["objectId"] + '/medias/previews/preview' + (this.entity as any)["colorId"] + '-sm.webp';
        }
        let preview = document.getElementById('previewArrangement');
        if (preview) {
            let img = preview.querySelector('img');
            if (img) {
                img.src = this.itemPreview;
            }
        }
    }

    isArrangementModelSelected(modele: any): boolean {
        var d = new Date();

        if (((d.getTime() / 500) & 1) === 0) {
            return (false);
        }

        if (this.entity.objectId === modele._id) {
            return (true);
        }

        return (false);
    };

    getArrangementModelOpacity(modele: any): string {
        if (this.isArrangementModelSelected(modele)) {
            return ('#f5d23180');
        }
        else {
            return ('#f5d23100');
        }
    };
}